import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmLink from '~/components/atoms/MdmLink';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bx-chevron-right.svg';
export default {
  name: 'ArrowLink',
  components: {
    MdmLink: MdmLink
  },
  props: {
    url: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
};